import React from "react";
import { LinkForButton } from "../../components/links/LinkForButton";
import { Button } from "@mui/material";
import { useTranslation } from "react-i18next";

interface PropertyEditButtonProps {
  propertyId: string;
  disabled?: boolean;
  to?: string;
}

export const PropertyEditButton: React.FC<PropertyEditButtonProps> = ({
  propertyId,
  disabled,
  to,
}) => {
  const { t } = useTranslation();

  const ButtonComponent = (
    <Button variant="contained" disabled={disabled}>
      {t("propertyEdit.addPropertyFeatures")}
    </Button>
  );

  if (disabled) {
    return ButtonComponent;
  }

  return (
    <LinkForButton
      to={to ?? `/properties/${propertyId}/details`}
      style={{ alignSelf: "center", margin: "15px 0" }}
    >
      {ButtonComponent}
    </LinkForButton>
  );
};
